import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AiAssistant } from "@/components/AiAssistant";
import { Bot, ArrowRight } from "lucide-react";

export default function AiAssistantPage() {
  return (
    <div>
      <section className="relative border-b border-white/10 overflow-hidden grain">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold/10 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 relative">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="flex items-center gap-2 text-gold text-xs uppercase tracking-[0.25em] mb-5">
              <span className="h-px w-8 bg-gold" /> AI Website Assistant
            </div>
            <div className="flex items-start justify-between gap-6 flex-wrap">
              <div>
                <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter font-light text-white leading-[1.05] flex items-center gap-4">
                  <span className="w-12 h-12 border border-gold/40 flex items-center justify-center text-gold"><Bot size={26} strokeWidth={1.5} /></span>
                  Chat with the ATF Assistant
                </h1>
                <p className="text-base text-gray-300 font-light mt-4 max-w-2xl leading-relaxed">
                  Get instant help with website copy, SEO, branding, and structure. Start with a prompt or ask anything — your conversation is saved automatically.
                </p>
              </div>
              <Link to="/start" data-testid="assistant-start-project" className="hidden md:inline-flex items-center gap-2 border border-white/25 text-white px-6 py-3 font-medium hover:bg-white/5 hover:border-gold/50 transition-colors">
                Start a project <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 md:py-10">
        <AiAssistant scope="public" />
      </div>
    </div>
  );
}
